import { render } from "./HistoryClaim.vue?vue&type=template&id=7306cc12&scoped=true&ts=true"
import script from "./HistoryClaim.vue?vue&type=script&lang=ts"
export * from "./HistoryClaim.vue?vue&type=script&lang=ts"

import "./HistoryClaim.vue?vue&type=style&index=0&id=7306cc12&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7306cc12"]])

export default __exports__